import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '../../services/auth-guard.service';
import { ConfigGuardService } from '../../services/config-guard.service';
import { ArticleCompareComponent } from './components/article-compare/article-compare.component';
import { ArticleDetailComponent } from './components/article-detail/article-detail.component';
import { ArticleComponent } from './components/article/article.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'suche',
        component: ArticleComponent,
        canActivate: [AuthGuardService, ConfigGuardService]
      },
      {
        path: 'details/:articleOid',
        component: ArticleDetailComponent,
        canActivate: [AuthGuardService, ConfigGuardService]
      },
      {
        path: 'vergleich',
        component: ArticleCompareComponent,
        canActivate: [AuthGuardService, ConfigGuardService]
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'suche'
      }
      //{ path: '**', component: Page404leavesComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ArticleRoutingModule { }
